/** 看板后端导出：单元格与前端 xlsx 一致按字符串写出 */
export function dashboardTableExportCellString(v: unknown): string {
    if (v === null || v === undefined) return '';
    if (typeof v === 'number') return Number.isFinite(v) ? String(v) : '';
    if (typeof v === 'string') return v;
    return '';
}
